import { Divider, Stack } from '@mui/material';
import { PriceSuggestionPriority } from './PriceSuggestionPriority';
import { AvailablePriceSuggestions } from './AvailablePriceSuggestions';
import { PriceSuggestionType } from '@retail/products/types';
import { useCallback } from 'react';

interface Props {
  priceSuggestionPriority: PriceSuggestionType[];
  availablePriceSuggestions: PriceSuggestionType[];
  getPriceTypeValue: (priceType: PriceSuggestionType) => string;
  updatePriceSuggestionPrioritazion: (newPrio: PriceSuggestionType[]) => void;
}

export function PriceSuggestionPrioritization({
  priceSuggestionPriority,
  availablePriceSuggestions,
  updatePriceSuggestionPrioritazion,
  getPriceTypeValue,
}: Props) {
  const handlePriceSuggestionPrioritization = useCallback(
    (value: PriceSuggestionType) => {
      updatePriceSuggestionPrioritazion(
        priceSuggestionPriority.includes(value)
          ? priceSuggestionPriority.filter((priority) => priority !== value)
          : [...priceSuggestionPriority, value]
      );
    },
    [priceSuggestionPriority, updatePriceSuggestionPrioritazion]
  );

  const handleReprioritizedPriceSuggestions = useCallback(
    (priceTypeIndex: number, prioritize: 'UP' | 'DOWN') => {
      const newIndex = prioritize === 'UP' ? priceTypeIndex - 1 : priceTypeIndex + 1;
      const newPrioritazion = [...priceSuggestionPriority];
      [newPrioritazion[priceTypeIndex], newPrioritazion[newIndex]] = [
        newPrioritazion[newIndex],
        newPrioritazion[priceTypeIndex],
      ];
      updatePriceSuggestionPrioritazion(newPrioritazion);
    },
    [priceSuggestionPriority, updatePriceSuggestionPrioritazion]
  );
  return (
    <Stack
      display="flex"
      flexDirection="row"
      flexGrow={1}
      border={(theme) => `1px solid ${theme.vars.palette.divider}`}
    >
      <PriceSuggestionPriority
        selectedPriceSuggestionTypes={priceSuggestionPriority}
        checkPriceType={handlePriceSuggestionPrioritization}
        handleReprioritizedPriceSuggestions={handleReprioritizedPriceSuggestions}
        getPriceTypeValue={getPriceTypeValue}
      />
      <Divider orientation="vertical" sx={{ height: 'auto' }} />
      <AvailablePriceSuggestions
        priceSuggestionTypes={availablePriceSuggestions}
        checkedPriceTypes={priceSuggestionPriority}
        checkPriceType={handlePriceSuggestionPrioritization}
        getPriceTypeValue={getPriceTypeValue}
      />
    </Stack>
  );
}
